import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { SchoolMember } from '../../models/member.school.model';
import * as teacherActions from '../actions/teacher.school.actions';

export interface TeacherState extends EntityState<SchoolMember> {
  loading: boolean;
  loaded: boolean;
  inProgress: boolean;
  memberStatsLoading: boolean;
  error: AppExceptionModel | undefined;
}

export const teacherAdapter: EntityAdapter<SchoolMember> =
  createEntityAdapter<SchoolMember>();

export const initialState: TeacherState = teacherAdapter.getInitialState({
  loading: false,
  loaded: false,
  inProgress: false,
  memberStatsLoading: false,
  error: undefined,
});

export const teacherReducer = createReducer(
  initialState,
  on(teacherActions.getStudents, (state, {}) => ({
    ...state,
    loading: true,
    loaded: false,
    error: undefined,
  })),
  on(teacherActions.getStudent, (state, {}) => ({
    ...state,
    error: undefined,
  })),
  on(teacherActions.getStudentStatsDone, (state, {}) => ({
    ...state,
    loading: false,
    error: undefined,
  })),
  on(teacherActions.addStudentToStore, (state, { member }) =>
    teacherAdapter.upsertOne(member, {
      ...state,
      error: undefined,
      loading: false,
      loaded: true,
    }),
  ),
  on(teacherActions.addStudentsToStore, (state, { members }) => {
    return teacherAdapter.upsertMany(members, {
      ...state,
      loading: false,
      loaded: true,
      inProgress: false,
      error: undefined,
    });
  }),
  on(teacherActions.getChildrenDone, (state, { members }) => {
    return teacherAdapter.upsertMany(members, {
      ...state,
      loading: false,
      loaded: true,
      inProgress: false,
      error: undefined,
    });
  }),
  //   on(gradeActions.linkTeacherSuccess, (state, { teachers }) =>
  //     teacherAdapter.upsertMany(teachers, {
  //       ...state,
  //       error: undefined,
  //       inProgress: false,
  //     })
  //   ),
  //   on(teacherActions.getMemberStats, (state) => ({
  //     ...state,
  //     SchoolMemberStatsLoading: true,
  //   })),
  //   on(teacherActions.getMemberStatsDone, (state) => ({
  //     ...state,
  //     SchoolMemberStatsLoading: false,
  //   })),
  //   on(teacherActions.getMemberStatsFailure, (state) => ({
  //     ...state,
  //     SchoolMemberStatsLoading: false,
  //   })),
  on(teacherActions.getStudentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error: error,
  })),
  on(teacherActions.clear, (state) => initialState),
);
